export default (livePlayerWrapper: any, playerConfig: any, credentials: any) =>
  // @ts-ignore
  OnePlayer.isSupported(playerConfig)
    .then(() => {
      // @ts-ignore
      return new OnePlayer(livePlayerWrapper, playerConfig, credentials);
    })
    .catch(() => false);
